import { defineMessages } from 'react-intl';

export default defineMessages({
    policyChanges: {
        id: 'premier.policychange.recMarLine.views.policyChangesPage.Policy Changes',
        defaultMessage: 'Policy Changes'
    },
    policyChangeEffectiveDate: {
        id: 'premier.policychange.recMarLine.views.policyChangesPage.Policy Change Effective Date',
        defaultMessage: 'Policy Change Effective Date'
    },
    description: {
        id: 'premier.policychange.recMarLine.views.policyChangesPage.Description:',
        defaultMessage: 'Description:'
    },
    secondaryNamedInsured: {
        id: 'premier.policychange.recMarLine.views.policyChangesPage.Secondary Named Insured',
        defaultMessage: 'Secondary Named Insured'
    },
    add: {
        id: 'premier.policychange.recMarLine.views.policyChangesPage.Add',
        defaultMessage: 'Add'
    },
    address: {
        id: 'premier.policychange.recMarLine.views.policyChangesPage.Address',
        defaultMessage: 'Address'
    },
    policyType: {
        id: 'premier.policychange.recMarLine.views.policyChangesPage.PolicyType.label',
        defaultMessage: 'What policy type is this associated with?'
    },
    baseState: {
        id: 'premier.policychange.recMarLine.views.policyChangesPage.BaseState',
        defaultMessage: 'Base State'
    },
    riskType: {
        id: 'premier.policychange.recMarLine.views.policyChangesPage.riskType',
        defaultMessage: 'Risk Type'
    },
});
